import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import SpaceBarIcon from '@mui/icons-material/SpaceBar';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, Typography } from '@mui/material';
import useStyles from '../KaraokeStyles';

const SyncFileInstructions = () => {
    const classes = useStyles()
    return (
        <>
            <Typography className={classes.instructions}>
                On desktop, press{' '}
                <Typography component="span" style={{ color: 'purple', fontWeight: 500 }}>
                    spacebar
                </Typography>{' '}
                <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <SpaceBarIcon fontSize="small" style={{ color: 'purple', marginLeft: 1, verticalAlign: 'middle' }} />
                </Box>{' '}
                or tap the{' '}
                <Typography component="span" style={{ color: '#142C5C', fontWeight: 500 }}>
                    Sync Next Line
                </Typography>{' '}
                <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <SkipNextIcon fontSize="small" style={{ color: '#142C5C', marginLeft: 1, verticalAlign: 'middle' }} />
                </Box>{' '}
                button (recommended on mobile) to sync each lyric with the audio.
            </Typography >
            <Typography className={classes.instructions}>
                When you hear a line, tap the button (or press space) to mark its timestamp.
            </Typography>
            <Typography className={classes.instructions}>
                Press{' '}
                <Typography component="span" sx={{ fontWeight: 500, color: 'red' }}>
                    delete
                </Typography>{' '}
                <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <DeleteIcon fontSize="16px" style={{ color: 'red', marginLeft: 1, verticalAlign: 'middle' }} />
                </Box>{' '}
                / backspace, or tap{' '}
                <Typography component="span" style={{ color: '#142C5C', fontWeight: 500 }}>
                    Remove Last
                </Typography>{' '}
                <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <UndoIcon fontSize="16px" style={{ color: '#142C5C', marginLeft: 1, verticalAlign: 'middle' }} />
                </Box>{' '}
                to undo the last synced line.
            </Typography>
            <Typography className={classes.instructions}>
                Tap a line to play from its timestamp, or double-tap to edit it and press{' '}
                <Typography component="span" style={{ color: 'purple', fontWeight: 500 }}>
                    enter
                </Typography>{' '}
                <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <KeyboardReturnIcon fontSize="14px" style={{ color: 'purple', marginLeft: 1, verticalAlign: 'middle' }} />
                </Box>{' '}
                to save.
            </Typography>

        </>
    )
}

export default SyncFileInstructions
